import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  to?: string;
  toLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  to,
  toLabel,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        <p className="flex items-center gap-2 font-label text-xs tracking-[0.25em] text-primary-600">
          <span className={`h-px w-6 bg-primary-500 ${centered ? "hidden" : ""}`} />
          {eyebrow}
        </p>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {to && toLabel && (
        <Link
          to={to}
          className="group inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {toLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}